import css from './Page.module.scss'
import React, { useState } from 'react'
import { MapRef } from 'react-map-gl/mapbox'
import { Outlet } from 'react-router-dom'

import Footer from 'client/components/Layout/Footer'
import Header from 'client/components/Layout/Header'
import Map from 'client/components/Map'
import { MapContext } from 'client/components/Map/context'

const Page: React.FC = () => {
  const [mapRef, setMapRef] = useState<MapRef>()

  return (
    <MapContext.Provider value={{ mapRef }}>
      <div className={css.page}>
        <Map setMapRef={setMapRef} />
        <Header />
        <Outlet />
      </div>
      <Footer />
    </MapContext.Provider>
  )
}

export default Page
